// extracted by mini-css-extract-plugin
export default {"column__container":"styles_column__container__y7TPF","column__text--host-name":"styles_column__text--host-name__6kp9v","column__text--brand":"styles_column__text--brand__xZGZT"};